const actions = {
  saveProduct: async ({commit, getter, rootGetters}, payload) => {
       // do check on data here that keys are filled properly
  },

};
export default actions
